import { useContext, useEffect, useState } from "react";
import CountryConfigContext from "../../../../CountryConfigContext";
import useCountryAxiosInstance from "../../../../hooks/useCountryAxiosInstance";

export const fetchProductsById = (apiRequest, ids) =>
  apiRequest.get(`/products/all?ids=${ids.join(",")}`);

export const getConfiguratorProductsToFetch = (data, config) =>
  data
    .reduce((acc, step) => [...acc, ...step.products], [])
    .filter((id) => !config.products[id])
    .filter((id, idx, arr) => arr.indexOf(id) === idx);  // drop duplicates in order to avoid requests with unnecessary long urls

export const reduceProducts = (products) =>
  products.reduce((acc, product) => ({ ...acc, [product.id]: product }), {});

const useFetchFixedProducts = (data) => {
  const [fetchFixedProducts, setFetchFixedProducts] = useState(false);
  const { setConfig, config } = useContext(CountryConfigContext);
  const apiRequest = useCountryAxiosInstance();
  useEffect(() => {
    const fetchProducts = async (ids) => {
      try {
        const products = await fetchProductsById(apiRequest, ids);
        setConfig({
          ...config,
          products: {
            ...config.products,
            ...reduceProducts(products),
          },
        });
        setFetchFixedProducts(true);
      } catch (error) {
        console.log(error);
        setFetchFixedProducts("error");
      }
    };

    if (data && !fetchFixedProducts) {
      const productsToFetch = getConfiguratorProductsToFetch(data, config);

      if (productsToFetch.length) {
        fetchProducts(productsToFetch);
      } else {
        setFetchFixedProducts(true);
      }
    }

    // eslint-disable-next-line
  }, [data]);

  return fetchFixedProducts;
};

export default useFetchFixedProducts;
